import { convertModeToKey } from './convertModeToKey';
import { HotkeyCommand } from 'owa-hotkeys/lib/types/HotkeyCommand';
import fixUpHotkeyCommand from 'owa-hotkeys/lib/utils/fixupHotkeyCommand';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function hasKeybindForCurrentMode(command: HotkeyCommand) {
    // Get the name of the keyboard shortcuts style the user has enabled.
    const keyboardShortcutsMode = getUserConfiguration().UserOptions.KeyboardShortcutsMode;
    const modeKey = convertModeToKey(keyboardShortcutsMode);

    return fixUpHotkeyCommand(command)[modeKey] !== undefined;
}
